/**
 * Degrees in alphabetical order by name, for the program dropdowns (the
 * application's program question and the request-info "Field of Interest").
 * `/campus-degrees` returns them in no particular order (the query has no
 * ORDER BY), so a list would otherwise shuffle whenever the table changes.
 * Case-insensitive, with numbers compared by value; ties keep the API order.
 * Returns a new array and leaves the one given untouched.
 */
export function sortDegreesByName<T extends {name?: string | null}>(
  degrees: readonly T[] = [],
): T[] {
  return [...degrees].sort((a, b) =>
    (a?.name ?? '').localeCompare(b?.name ?? '', 'en', {
      sensitivity: 'base',
      numeric: true,
    }),
  )
}
